module.exports = __webpack_public_path__ + "img/map-example.b98a2d2.png";